export default __webpack_public_path__ + "static/media/icon-close-menu.32169d31.svg";